import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-note-popup',
  templateUrl: './note-popup.component.html',
  styleUrls: ['./note-popup.component.scss']
})
export class NotePopupComponent implements OnInit {
  @Output() onClickOk = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

  onReadNote() {
    this.onClickOk.emit();
  }

}
